import { Link } from "react-router-dom";

const S = {
  page: {
    backgroundColor: "#FFF4B8",
    minHeight: "100vh",
    fontFamily: "Arial, sans-serif",
    color: "#111",
    fontSize: "15px",
    lineHeight: "1.6",
  },
  wrap: {
    maxWidth: "660px",
    margin: "0 auto",
    padding: "36px 20px 60px",
  },
  h1: {
    fontFamily: "Arial",
    fontWeight: "bold",
    fontSize: "22px",
    margin: "0 0 20px",
    paddingBottom: "10px",
    borderBottom: "1px solid #bbb",
  },
  p: {
    margin: "0 0 14px",
    fontFamily: "Arial",
    fontSize: "15px",
  },
  ul: {
    margin: "0 0 14px",
    paddingLeft: "24px",
  },
  li: {
    marginBottom: "6px",
    fontFamily: "Arial",
    fontSize: "15px",
  },
  back: {
    color: "blue",
    textDecoration: "underline",
    fontFamily: "Arial",
    fontSize: "15px",
  },
};

export default function Rules() {
  return (
    <div style={S.page}>
      <div style={S.wrap}>
        <h1 style={S.h1}>Rules</h1>

        <p style={S.p}>
          This is a public, anonymous website. Please use it responsibly.
        </p>

        <p style={S.p}>Don't post:</p>
        <ul style={S.ul}>
          <li style={S.li}>
            <strong>Personal information.</strong> Do not post phone numbers, email addresses, home addresses, private identifying information, or other people's personal information.
          </li>
          <li style={S.li}>
            <strong>Threats or violence.</strong> Do not threaten, encourage, organize, celebrate, or solicit violence or serious physical harm against yourself or anyone else.
          </li>
          <li style={S.li}>
            <strong>Hate or dehumanization.</strong> Do not attack, demean, exclude, or describe people as inferior or less human based on race, ethnicity, nationality, religion, gender, gender identity, sexual orientation, disability, or other protected characteristics.
          </li>
          <li style={S.li}>
            <strong>Harassment or intimidation.</strong> Do not use the site to target, stalk, intimidate, humiliate, or coordinate harassment of a person or group.
          </li>
          <li style={S.li}>
            <strong>Harmful or illegal activity.</strong> Do not use the site to organize, solicit, facilitate, or provide instructions for criminal activity.
          </li>
          <li style={S.li}>
            <strong>Sexual exploitation or abuse.</strong> Do not post content that sexually exploits, abuses, or endangers anyone, especially minors.
          </li>
          <li style={S.li}>
            <strong>Spam or manipulation.</strong> Do not flood the site with repeated submissions, automated submissions, advertising, scams, or attempts to manipulate help counts.
          </li>
        </ul>

        <p style={S.p}>
          A few things are not against the rules just because they may make someone uncomfortable.
        </p>
        <p style={S.p}>
          Profanity by itself is allowed. So are strange ideas, jokes, political ideas, controversial opinions, criticism, unpopular views, and ideas that other people think are foolish.
        </p>
        <p style={S.p}>
          Discussing violence, racism, illegal activity, or another sensitive subject is not automatically prohibited. Context matters.
        </p>
        <p style={S.p}>
          The distinction is simple: you can discuss difficult things. You cannot use this site to threaten, abuse, target, exploit, or seriously endanger people.
        </p>
        <p style={S.p}>
          Posts are automatically checked before publication and may also be reviewed or hidden afterward.
        </p>
        <p style={S.p}>
          These rules are intentionally conservative because the site is anonymous and publicly visible.
        </p>
        <p style={S.p}>
          If something seems close to one of these boundaries, don't post it.
        </p>

        <p style={{ ...S.p, marginTop: "28px" }}>
          <Link to="/" style={S.back}>Back</Link>
        </p>
      </div>
    </div>
  );
}
